import { reject } from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '@src/components/SectionTitle';
import apolloClient from '@src/graphql/apollo';
import { GetSpecialitiesDocument, GetSpecialitiesQuery } from '@src/graphql/generated';
import Speciality from './Speciality';

export default class Specialities extends PureComponent {
  static propTypes = {
    activeSpeciality: PropTypes.object,
    setSpeciality: PropTypes.func.isRequired,
  };

  _isMounted = false;

  state = {
    specialities: [],
  };

  async componentDidMount() {
    this._isMounted = true;
    const {
      data: { specialities },
    } = await apolloClient.query<GetSpecialitiesQuery>({
      fetchPolicy: 'no-cache',
      query: GetSpecialitiesDocument,
    });

    if (this._isMounted) {
      this.setState({ specialities: reject(specialities, { key: 'other' }) });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { activeSpeciality, setSpeciality } = this.props;
    const { specialities } = this.state;

    return (
      <div className="specialities">
        <SectionTitle
          subtitle="What kind of a position do you want to fill"
          title="I'm looking for someone whose speciality is"
        />

        <div className="grid-selection three">
          {specialities.map(speciality => {
            return (
              <Speciality
                active={!!activeSpeciality && activeSpeciality.id === speciality.id}
                key={speciality.id}
                setSpeciality={setSpeciality}
                speciality={speciality}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
